function cardList() {
    var icon = document.querySelectorAll('.card-listing__icon')

    icon.forEach(function (el) {
        el.addEventListener('click', function (event) {
            var parent = event.target.closest('.card-listing'),
                grid = parent.querySelector('.card-listing__grid'),
                card = parent.querySelectorAll('.card'),
                iconContainer = event.target.parentNode

            // add & remove active classes on icons
            iconContainer.querySelectorAll('.card-listing__icon').forEach(function(e) {
                e.classList.remove('card-listing__icon--active')
            })
            el.classList.add('card-listing__icon--active')

            // switch grid classes
            if (el.classList.contains('icon--grid')) {
                if (!grid.classList.contains('grid')) {
                    grid.classList.add('grid')
                    grid.classList.add('grid--2')

                    card.forEach(function (e) {
                        e.classList.add('bg--grey')
                        // e.classList.add('card--simple')
                        e.classList.remove('card--list')
                    })
                }
            } 
            
            else {
                if (grid.classList.contains('grid')) {
                    grid.classList.remove('grid')
                    grid.classList.remove('grid--2')

                    card.forEach(function (e) {
                        e.classList.remove('bg--grey')
                        // e.classList.remove('card--simple')
                        e.classList.add('card--list')
                    })
                }
            }
        })
    })
}
